import React from "react";
import PaymentMethod from "../components/paymentMethod/paymentMethod";

export default function PaymentMethodsRouter() {
  return <PaymentMethod />;
}
